import { Model } from 'modules/core/lib/mobx-rest'

interface ILegalGender {
  [key: string]: any
}

class LegalGender extends Model<ILegalGender> {
  static urlRoot() {
    return '/legal_genders'
  }
}

export default LegalGender
